    // react
    import React, { useEffect, useContext } from 'react';
    import useForm from 'react-hook-form';
    import {Link} from "react-router-dom";
    import { useTranslation } from 'react-i18next';

    // material-ui icons
    import FormHelperText from "@material-ui/core/FormHelperText";

    // material-ui components
    import TextField from '@material-ui/core/TextField';

    // core components
    import GridContainer from "beaktShared/components/Grid/GridContainer.js";
    import GridItem from "beaktShared/components/Grid/GridItem.js";
    import Button from "beaktShared/components/CustomButtons/Button.js";
    import Card from "beaktShared/components/Card/Card.js";
    import CardBody from "beaktShared/components/Card/CardBody.js";
    import HeaderProcessoFinal from "beaktClinic/views/Venda/Header/HeaderProcessoFinal"
    import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
    import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1} from "beaktShared/helpers/masks";
    import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

    // services
    import { SessionContext } from "beaktShared/services/session";
    import { setcarrinhoVendaCookie, getcarrinhoVendaCookie } from "beaktClinic/services/carrinhoVenda";
    import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

    // style
    import { makeStyles } from "@material-ui/core/styles";
    import styles from "assets/jss/BeaktClinic/views/Venda/carrinhoVenda.js";
import { setConstantValue } from 'typescript';
    const useStyles = makeStyles(styles);

    export default function CarrinhoVenda() {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, errors,setValue} = useForm({mode: "onBlur"});   

    const [loadingCarrinho] = React.useState(false);
    const [loadCarrinho, setloadCarrinho] = React.useState(getcarrinhoVendaCookie());

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
            show:true,
            color:color,
            message:message      
        });
        setTimeout(function() {
            setNotification({show:false});
        }, 6000);       
    };

    useEffect(() => {      
        calculaTotalizadorItens(loadCarrinho);    
    }, []);
    
    const calculaTotalizadorItens = (loadCarrinho) =>{
        // Valido se o carrinho esta preenchido
        // Assim posso ver se o tipo adicionado é produto, e se o mesmo
        // Valida estoque
        if (loadCarrinho.itens.length > 0)
        {
            for (let i = 0; i < loadCarrinho.itens.length; i++) {
                const item = loadCarrinho.itens[i];
                if (item.tipoItem === 0 && item.controlaEstoque === true) {
                    if (item.qtd > item.saldoEstoque) {
                        item.qtd = item.saldoEstoque;
                        return;
                    }
                }
            }
        }

        let valortotalItens = 0;
        let valortotalDescontos = 0;
        let valorTotalItensComDesconto = 0;
        let qtdTotalItens = 0;

        loadCarrinho.itens.map(item =>{
            qtdTotalItens = qtdTotalItens + item.qtd;
            valortotalItens = valortotalItens + item.valorTotal;
            valortotalDescontos = valortotalDescontos + item.valorDesconto;
            valorTotalItensComDesconto = valorTotalItensComDesconto + item.valorTotalComDesconto;
        });

        let updateCarrinho ={
            ...loadCarrinho,  
            qtdItensTotalCarrinho: qtdTotalItens,    
            totalizadorItens:{
                totalItens: valortotalItens,
                totalDescontos:valortotalDescontos,
                TotalItensComDesconto:valorTotalItensComDesconto
            }
        };
    
        setloadCarrinho(updateCarrinho);
        setcarrinhoVendaCookie(updateCarrinho);
    }

    const handleRemoveItem = (item) =>{

        let listFiltered = loadCarrinho.itens.filter(obj => {
            return obj.id !== item.id;
        });
        
        let newLC = {
            ...loadCarrinho,
            itens:listFiltered
        }    
        calculaTotalizadorItens(newLC);   
    }

    const handleChangeQtdItemAdd = (e,item) => {
        // Valida se o produto controle estoque e seu saldo
        if (item.tipoItem === 0 && item.controlaEstoque === true) {
            if (e.target.value > item.saldoEstoque) {
                item.qtd = item.saldoEstoque;
                e.target.value = item.saldoEstoque;
            }
            else {
                item.qtd = e.target.value;
            }
        }
        else {
            item.qtd = e.target.value;
        }

        calculaTotalizadorByEvent(e,item);  
    }
    
    const handleRestDescont = (e) => {
        if(e.target.value === ""){
            e.target.value = "0"
            return; 
        }
    }

    const handleChangeDescontoMoneyItemAdd = (e,item) =>{
        let desconto = 0;
        if (e.target.value !== "")
            desconto = transformValueFormatedtoFloat(e.target.value);

        if (desconto > item.valorTotal)
        {
            desconto = item.valorTotal;
            e.target.value = transformValueFloattoFormated(desconto);
        }

        if (item.valorDescontoPercent > 0)
            item.valorDescontoPercent = 0;

        item.valorDesconto = desconto;
        setValue("descontoitemPercentual"+item.id,"")
        calculaTotalizadorByEvent(e,item);
    } 

    const handleChangeDescontoPercentualItemAdd = (e,item) =>{
        let descontoPercent = 0;
        if(e.target.value !== "")
            descontoPercent = transformValueFormatedtoFloat(e.target.value);        
        
        item.valorDescontoPercent = descontoPercent;

        // Se o campo de porcentagem for zerado, também zeramos o valor de desconto
        if (descontoPercent == 0) {
            item.valorDesconto = 0;
        }

        setValue("descontoitem"+item.id,"")
        calculaTotalizadorByEvent(e,item);        
    }    

    const calculaTotalizadorByEvent = (e,item) => {
        // Aqui vamos validar se o produto controle estoque
        let maximoLimiteDesconto = item.maximoLimiteDesconto;
        var eQtd = 0;
        if (item.tipoItem === 0 && item.controlaEstoque === true) {
            if (e.target.value > item.saldoEstoque) {
                eQtd = item.saldoEstoque;
            }
            else {
                eQtd = e.target.value;
            }
        }

        let total = item.valorUnitario * parseInt(item.qtd);      
        let desconto = 0;
        
        if (item.valorDescontoPercent != 0 && item.valorDescontoPercent != null && item.valorDescontoPercent != "") {
            desconto = (item.valorUnitario * item.qtd) * (item.valorDescontoPercent/100);
            if(desconto > item.valorTotal)
            {
                desconto = item.valorTotal;
                eQtd = transformValueFloattoFormated(desconto);
            }
        }
        else if (item.valorDesconto != 0) {
            desconto = item.valorDesconto;
        }
        
        let totalComDesconto = total - desconto;

        if (maximoLimiteDesconto !== null)
        {
            if (maximoLimiteDesconto < 100)
            {
                if (item.valorDescontoPercent != 0 && item.valorDescontoPercent != null && item.valorDescontoPercent != "") 
                {
                    if (item.valorDescontoPercent > maximoLimiteDesconto)
                    {
                        total = item.valorUnitario * parseInt(item.qtd);
                        desconto = 0;
                        totalComDesconto = total;
                        item.valorDescontoPercent = 0;
                        setValue('descontoitemPercentual'+item.id, '0,00');
                        showNotification('Valor de desconto superior ao limite permitido. Desconto não autorizado.','danger');
                    }
                }
                else if (item.valorDesconto != 0)
                {
                    let valorLimiteMaximo = ((total * maximoLimiteDesconto) / 100);
                    if (item.valorDesconto > valorLimiteMaximo)
                    {
                        total = item.valorUnitario * parseInt(item.qtd);
                        desconto = 0;
                        totalComDesconto = total;
                        item.valorDescontoPercent = 0;
                        setValue('descontoitem'+item.id, '0,00');
                        showNotification('Valor de desconto superior ao limite permitido. Desconto não autorizado.','danger');
                    }
                }
            }
        }

        item.valorTotal = total;
        item.valorDesconto = desconto;
        item.valorTotalComDesconto = totalComDesconto; 
        
        let itens = loadCarrinho.itens.map(l => (l.id === item.id ? item : l)); 
        let newLC = {
            ...loadCarrinho,
            itens:itens,
        }
        
        calculaTotalizadorItens(newLC);      
    }  

    return (
        <div className="maxContent">  
            
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({show:false})}
                close
            />   

            <HeaderProcessoFinal etapa={0}></HeaderProcessoFinal>    
            <GridContainer>
            
                <GridItem xs={12} sm={12} md={9}>
                <Card>
                <CardBody>                        

                    {loadingCarrinho && <div className="carregando">{t('label.loading')}...</div>}
                                                
                    <br/>
                                                                                
                    {loadCarrinho.itens.map(item => (                       
                    <GridContainer key={item.id}>                                             
                            <GridItem md={9} xs={9} sm={9}>
                                <h4 className={classes.titleItem}>
                                    {item.descricao}                            
                                </h4>                            
                            </GridItem>
                            <GridItem md={3} xs={3} sm={3} className="text-right">
                                <small className={classes.subTitleItem}>                            
                                {item.tipoItem === 0 &&
                                    <label> {t('label.product').toUpperCase()}  </label>
                                }
                                {item.tipoItem === 1 &&
                                    <label> {t('label.service').toUpperCase()} </label>
                                }
                                {item.tipoItem === 2 &&
                                    <label> {t('label.package').toUpperCase()} </label>
                                }
                                </small>
                            </GridItem>   
                            <br/>
                            <GridItem md={12} xs={12} sm={12} className={classes.lineItem}>
                            </GridItem>                                    
                            <br/>
                            <GridItem md={2} xs={2} sm={2}>   
                                <div className={classes.mt10}>                  
                                    <TextField
                                        variant="outlined"
                                        InputLabelProps={{shrink: true}} 
                                        defaultValue={t('label.money_symbol') + item.valorUnitario}                                      
                                        type="text"     
                                        label={t('label.price')}        
                                        disabled={true}
                                    />                                
                                </div>  
                            </GridItem>  
                            <GridItem md={2} xs={2} sm={2} >
                                <div className={classes.mt10}>
                                    <TextField
                                        label={t('label.qty')}
                                        variant="outlined"
                                        InputLabelProps={{shrink: true}} 
                                        defaultValue={item.qtd}  
                                        name="qtditem"                                            
                                        type="number"             
                                        onChange={(e) => handleChangeQtdItemAdd(e,item)}                                       
                                        inputProps={{maxLength: 3}} 
                                        onInput={(e) => MaskOnlyNumbersStart1(e) }          
                                        inputRef={register({required: true})}
                                        error={errors.qtditem?true:false} 
                                    />
                                    <center>
                                    <a href="#" onClick={() => handleRemoveItem(item)} >
                                        {t('button.remove')}
                                    </a>
                                    </center>
                                    <FormHelperText>
                                        {errors.qtditem && <span> {t('label.required')}</span>}
                                    </FormHelperText> 
                                </div>
                            </GridItem>   
                            <GridItem md={3} xs={3} sm={3} >
                                <div className={classes.mt10}>
                                    <TextField
                                        label={'R$ '+t('label.discount')}
                                        variant="outlined"
                                        InputLabelProps={{shrink: true}} 
                                        defaultValue={transformValueFloattoFormated((item.valorDescontoPercent != 0 && item.valorDescontoPercent != null && item.valorDescontoPercent != "") ? "" : item.valorDesconto)}  
                                        name={"descontoitem"+item.id}
                                        onChange={(e) => handleChangeDescontoMoneyItemAdd(e,item)}  
                                        onBlur={(e) => handleRestDescont(e)}        
                                        inputRef={register({required: true})}
                                        InputProps={{ inputComponent: MaskMoney}} 
                                    />
                                </div>
                            </GridItem>
                            <GridItem md={3} xs={3} sm={3} >
                                <div className={classes.mt10}>
                                    <TextField
                                        label={'% '+t('label.discount')}
                                        variant="outlined"
                                        InputLabelProps={{shrink: true}} 
                                        defaultValue={transformValueFloattoFormated(item.valorDescontoPercent)}  
                                        name={"descontoitemPercentual"+item.id}
                                        onChange={(e) => handleChangeDescontoPercentualItemAdd(e,item)}          
                                        onBlur={(e) => handleRestDescont(e)}        
                                        inputRef={register({required: true})}                                   
                                    />                                
                                </div>
                            </GridItem>  
                            <GridItem md={2} xs={2} sm={2} >
                            <label>Total</label>
                            <div>
                                <b><label>{t('label.money_symbol')}</label> {transformValueFloattoFormated(item.valorTotalComDesconto)} </b>
                            </div>  
                            </GridItem>                        
                        </GridContainer>
                    ))}
                    
                    <br/><br/>

                    {loadCarrinho.itens.length === 0 &&
                    <div className="alertErrorEx ">                    
                        <p className="mt-4"> {t('sale.include_at_least_1_item_in_the_car')}  </p>
                    </div>
                    }

                    <Link to="/adminclinic/venda" >
                    + {t('sale.add_more_items_to_cart')} 
                    </Link>   
                    <br/>          
                </CardBody>
                </Card>
                </GridItem>
            
                <GridItem xs={12} sm={12} md={3}>            
                    <Card>
                        <CardBody>                         
                            <h6 className={classes.titleresumo}>
                            {t('sale.sale_summary')} 
                            </h6>
                        
                            <div className={classes.resumdesc}>
                                {t('sale.total_items')}
                                <div className={classes.valueResum}>
                                {t('label.money_symbol')} {transformValueFloattoFormated(loadCarrinho.totalizadorItens.totalItens)}
                                </div>
                                <Clearfix/>
                            </div>
                            <div className={classes.resumdesc2}>
                                {t('label.total')+" "}{t('label.discount')}
                                <div className={classes.valueResum}>
                                {t('label.money_symbol')} {transformValueFloattoFormated(loadCarrinho.totalizadorItens.totalDescontos)}
                                </div>
                                <Clearfix/>
                            </div>
                            <div className={classes.resumtotal}>
                                {t('label.total')}
                                <div className={classes.valueTotal}>
                                {t('label.money_symbol')} {transformValueFloattoFormated(loadCarrinho.totalizadorItens.TotalItensComDesconto)}
                                </div>
                            </div>
                            
                            {loadCarrinho.itens.length > 0 &&
                                <div>                                
                                    <Link to="/adminclinic/identificacaovenda" >
                                        <Button fullWidth color="primary" >
                                        {t('button.continue')}
                                        </Button>
                                    </Link>
                                </div>                        
                            }
                            
                        </CardBody>
                    </Card>  
                </GridItem>
            
            
            </GridContainer>
        </div>
    );
    }